import { render } from "./AddStudentDialog.vue?vue&type=template&id=272d02ae"
import script from "./AddStudentDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__